import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isActivated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private activeRequests = 0;
  listener: Observable<boolean> = this.isActivated.asObservable();

  constructor() { }

  // show: Increments the request counter and activates the loader on the first request
  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.isActivated.next(true);
    }
  }

  // hide: Decrements the request counter and deactivates the loader only when all requests are finished
  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this.isActivated.next(false);
    }
  }
  
  /**
   * Forcefully hide the loader regardless of the request count.
   * Useful for emergency error handling or page transitions.
   */
  forceHide(): void {
    this.activeRequests = 0;
    this.isActivated.next(false);
  }
}
